// GENERATED from equipment.store by tools/equipment-store.js — do not edit.
// Edit the store (or the knobs app Gear tab), then re-run the generator.
// The store is the single source of truth; this module is its projection
// the whole codebase imports (sim equip validation, arena gear panel,
// hero paper-doll, play.js).
// Rows are typed ItemDataRow (shared/items.ts): a projection missing a
// required field is a typecheck error; the catalog's load-time throw
// still catches value errors the type can't see (duplicate kinds etc.).
import type { ItemDataRow } from "./items.js";

export const ITEMS_DATA: readonly ItemDataRow[] = [
  {
    "kind": 4,
    "name": "Black Sword of Death",
    "slot": "weapon",
    "heroSlot": "weapon",
    "heroVariant": "sword-000000",
    "icon": "sword-000000",
    "shade": "#000000",
    "stats": {"atkMin":1,"atkMax":25,"speedTicks":48,"meleeAttack":60,"magicAttack":0},
    "weaponClass": "melee",
  },
  {
    "kind": 7,
    "name": "Sword of Light",
    "slot": "weapon",
    "heroSlot": "weapon",
    "heroVariant": "sword-f2ffe8",
    "icon": "sword-f2ffe8",
    "shade": "#f2ffe8",
    "stats": {"atkMin":1,"atkMax":60,"speedTicks":100,"meleeAttack":90,"magicAttack":0},
    "weaponClass": "melee",
  },
  {
    "kind": 9,
    "name": "Staff of Doom",
    "slot": "weapon",
    "heroSlot": "weapon",
    "heroVariant": "staff-000000",
    "icon": "staff-000000",
    "shade": "#000000",
    "stats": {"atkMin":1,"atkMax":25,"speedTicks":50,"meleeAttack":0,"magicAttack":90},
    "weaponClass": "magic",
    "spellType": "basic-bolt",
    "spellColor": "#000000",
    "spellRadius": 22,
  },
  {
    "kind": 10,
    "name": "Luminak'et",
    "slot": "weapon",
    "heroSlot": "weapon",
    "heroVariant": "staff-932092",
    "icon": "staff-932092",
    "shade": "#932092",
    "stats": {"atkMin":1,"atkMax":60,"speedTicks":120,"meleeAttack":0,"magicAttack":80},
    "weaponClass": "magic",
    "spellType": "basic-bolt",
    "spellColor": "#932092",
    "spellRadius": 22,
  },
  {
    "kind": 15,
    "name": "Holy Chestplate",
    "slot": "chest",
    "heroSlot": "torso",
    "heroVariant": "plate-ffffff",
    "icon": "plate-ffffff",
    "shade": "#ffffff",
    "stats": {"meleeDef":25,"magicDef":-10,"maxHp":0,"meleeAttack":10,"magicAttack":-20,"meleeDamageBonusPct":0,"magicDamageBonusPct":0},
  },
  {
    "kind": 16,
    "name": "Cursed Chestplate",
    "slot": "chest",
    "heroSlot": "torso",
    "heroVariant": "plate-220000",
    "icon": "plate-220000",
    "shade": "#220000",
    "stats": {"meleeDef":-10,"magicDef":0,"maxHp":0,"meleeAttack":30,"magicAttack":0,"meleeDamageBonusPct":10,"magicDamageBonusPct":-5},
  },
  {
    "kind": 18,
    "name": "Holy Greaves",
    "slot": "legs",
    "heroSlot": "leg",
    "heroVariant": "chaps-ffffff",
    "icon": "chaps-ffffff",
    "shade": "#ffffff",
    "stats": {"meleeDef":15,"magicDef":15,"maxHp":0,"meleeAttack":5,"magicAttack":5,"meleeDamageBonusPct":0,"magicDamageBonusPct":0},
  },
  {
    "kind": 19,
    "name": "Cursed Greaves",
    "slot": "legs",
    "heroSlot": "leg",
    "heroVariant": "chaps-220000",
    "icon": "chaps-220000",
    "shade": "#220000",
    "stats": {"meleeDef":0,"magicDef":0,"maxHp":0,"meleeAttack":15,"magicAttack":15,"meleeDamageBonusPct":5,"magicDamageBonusPct":5},
  },
  {
    "kind": 20,
    "name": "Extreme Boots",
    "slot": "feet",
    "heroSlot": "feet",
    "heroVariant": "boots-c061cb",
    "icon": "boots-c061cb",
    "shade": "#c061cb",
    "stats": {"meleeDef":5,"magicDef":0,"maxHp":0,"meleeAttack":10,"magicAttack":10,"meleeDamageBonusPct":10,"magicDamageBonusPct":10},
  },
  {
    "kind": 21,
    "name": "Wizard Robes",
    "slot": "chest",
    "heroSlot": "torso",
    "heroVariant": "robe-1a5fb4",
    "icon": "robe-1a5fb4",
    "shade": "#1a5fb4",
    "stats": {"meleeDef":-10,"magicDef":25,"maxHp":0,"meleeAttack":-20,"magicAttack":10,"meleeDamageBonusPct":0,"magicDamageBonusPct":0},
  },
  {
    "kind": 22,
    "name": "Cursed Robes",
    "slot": "chest",
    "heroSlot": "torso",
    "heroVariant": "robe-220000",
    "icon": "robe-220000",
    "shade": "#220000",
    "stats": {"meleeDef":0,"magicDef":-10,"maxHp":0,"meleeAttack":0,"magicAttack":30,"meleeDamageBonusPct":-5,"magicDamageBonusPct":10},
  },
  {
    "kind": 24,
    "name": "Stylish Cape",
    "slot": "chest",
    "heroSlot": "torso",
    "heroVariant": "cape-c061cb",
    "icon": "cape-c061cb",
    "shade": "#c061cb",
    "stats": {"meleeDef":-20,"magicDef":-20,"maxHp":0,"meleeAttack":20,"magicAttack":20,"meleeDamageBonusPct":10,"magicDamageBonusPct":10},
  },
  {
    "kind": 25,
    "name": "Stylish Hat",
    "slot": "helmet",
    "heroSlot": "head",
    "heroVariant": "hat-c061cb",
    "icon": "hat-c061cb",
    "shade": "#c061cb",
    "stats": {"meleeDef":0,"magicDef":0,"maxHp":0,"meleeAttack":5,"magicAttack":5,"meleeDamageBonusPct":5,"magicDamageBonusPct":5},
  },
  {
    "kind": 26,
    "name": "Cursed Hood",
    "slot": "helmet",
    "heroSlot": "head",
    "heroVariant": "hood-220000",
    "icon": "hood-220000",
    "shade": "#220000",
    "stats": {"meleeDef":-5,"magicDef":-5,"maxHp":0,"meleeAttack":10,"magicAttack":10,"meleeDamageBonusPct":5,"magicDamageBonusPct":5},
  },
];
